import React from "react";
import Button from "@surgia/ui/components/button";
import VisibleIcon from "@surgia/ui/icons/visible/visible.svg";
import InvisibleIcon from "@surgia/ui/icons/visible/invisible.svg";
import { ProductActionsProps } from "./types";

/**
 * Actions component for customer view toggle and save/cancel buttons
 */
const ProductActions: React.FC<ProductActionsProps> = ({
  customerView,
  isCustomerViewDisabled,
  isCustomerViewLoading,
  onToggleCustomerView,
  onCancel,
  onSave,
  isSaving,
  isDirty,
  hasErrors,
  isFormValid,
}) => {
  return (
    <div className="flex justify-between pt-4">
      {/* Customer View Toggle */}
      <div
        className={`flex items-center gap-3 cursor-pointer ${
          isCustomerViewDisabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
        onClick={onToggleCustomerView}
      >
        <img
          src={customerView ? VisibleIcon : InvisibleIcon}
          alt="visibility toggle"
          className="w-11 h-6"
        />
        <span className="text-sm font-medium text-gray-700">
          {isCustomerViewLoading ? "Updating..." : "Visible"}
        </span>
      </div>

      {/* Save/Cancel Buttons */}
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onCancel}
          disabled={isSaving || !isDirty}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={onSave}
          disabled={!isDirty || isSaving || hasErrors || !isFormValid}
          loading={isSaving}
        >
          {isSaving ? "Saving..." : "Save Changes"}
        </Button>
      </div>
    </div>
  );
};

export default ProductActions;
